// Require Twitter Bootstrap scripts
import 'bootstrap';
import Cookies from 'js-cookie';

var Flickity = require('flickity-imagesloaded');
var mixitup = require('mixitup');
var mixitupMultifilter = require('./mixitup-multifilter.min.js');
require('colcade');
mixitup.use(mixitupMultifilter);


/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Starter = {
		// All pages
		'common': {
			init: function() {

				// Menu toggle
				$(document).on('click', '.menu-toggle', function(evt) {
					evt.preventDefault();
					$('body').toggleClass('body--menu-active');
					$.scrollLock();
				});

				// Header link
				var $headerLink = $('.header_link');
				if($headerLink.length>0) {
					$(document).on('mouseenter', '.header_link', function() {
						$('.header').addClass('header--hovered');
					});
					$(document).on('mouseleave', '.header_link', function() {
						$('.header').removeClass('header--hovered');
					});
				}

				// Popup Newsletter
				const popup_newsletter = document.querySelector('[data-popup]');
				const popupCloseBtn = document.querySelector('[data-btn-close-popup]');
				const cookie = Cookies.get('popup_closed');

				if (cookie == null) {
					setTimeout(() => {
						popup_newsletter.classList.add('show');
					}, 5000);
				}

				function handleClosePopup() {
					popup_newsletter.classList.remove('show');
					Cookies.set('popup_closed', 'seen', { expires: 7 });
				}

				popupCloseBtn.addEventListener('click', () => {
					handleClosePopup();
				});

				$(document).on('click', (event) => {
					var $target = $(event.target);
					if(!$target.closest('[data-popup]').length &&
					$('[data-popup]').is(":visible")) {
						handleClosePopup();
					}
				});

				$(document).on('gform_confirmation_loaded', function(event, formId){
					if(formId == 1) {
						Cookies.set('popup_closed', 'seen', { expires: 7 });
						popup_newsletter.classList.add('form-sent');
					}

					if(formId == 3) {
						const modalProduct = document.querySelector('.modal--product');

						modalProduct.classList.add('form-sent');
					}
				});

				// Carousel Section
				var $carouselSections = $('.carousel');

				if (!$carouselSections) {
					return;
				}

				if($carouselSections.length>0) {
					for (var i = 0, len = $carouselSections.length; i < len; i++) {
						var $carouselSection = $carouselSections[i];
						new Flickity($carouselSection, {
							cellAlign: 'left',
							contain: true,
							adaptiveHeight: true,
							pageDots: false,
							imagesLoaded: true,
							arrowShape: 'M50,0c27.6,0,50,22.4,50,50s-22.4,50-50,50S0,77.6,0,50S22.4,0,50,0z M69.8,48.5c-0.2-0.1-0.4-0.2-0.6-0.2H43.4v-5.1c0-0.3-0.2-0.5-0.5-0.7c-0.3-0.1-0.6-0.1-0.9,0.1l-9.4,8.1c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5l9.4,8c0.2,0.2,0.6,0.2,0.9,0.1c0.3-0.1,0.5-0.3,0.5-0.7v-5.1h25.8c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-4.4C70,48.9,69.9,48.7,69.8,48.5L69.8,48.5z'
						});
					}
				}

				// Quickguide Section
				const $quickguideSections = $('.quickguide_carousel');

				if (!$quickguideSections) {
					return;
				}

				if($quickguideSections.length>0) {
					for (let i = 0, len = $quickguideSections.length; i < len; i++) {
						let $quickguideSection = $quickguideSections[i];
						new Flickity($quickguideSection, {
							cellAlign: 'left',
							wrapAround: true,
							pageDots: false,
							imagesLoaded: true,
							arrowShape: 'M50,0c27.6,0,50,22.4,50,50s-22.4,50-50,50S0,77.6,0,50S22.4,0,50,0z M69.8,48.5c-0.2-0.1-0.4-0.2-0.6-0.2H43.4v-5.1c0-0.3-0.2-0.5-0.5-0.7c-0.3-0.1-0.6-0.1-0.9,0.1l-9.4,8.1c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5l9.4,8c0.2,0.2,0.6,0.2,0.9,0.1c0.3-0.1,0.5-0.3,0.5-0.7v-5.1h25.8c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-4.4C70,48.9,69.9,48.7,69.8,48.5L69.8,48.5z'
						});
					}
				}

				// Gallery Section
				var $gallerySections = $('.gallery_carousel');
				if ($gallerySections.length > 0) {
					for (var i = 0, len = $gallerySections.length; i < len; i++) {
						var $gallerySection = $gallerySections[i];
						new Flickity($gallerySection, {
							cellAlign: 'left',
							contain: true,
							adaptiveHeight: false,
							pageDots: false,
							imagesLoaded: true,
							arrowShape: 'M50,0c27.6,0,50,22.4,50,50s-22.4,50-50,50S0,77.6,0,50S22.4,0,50,0z M69.8,48.5c-0.2-0.1-0.4-0.2-0.6-0.2H43.4v-5.1c0-0.3-0.2-0.5-0.5-0.7c-0.3-0.1-0.6-0.1-0.9,0.1l-9.4,8.1c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5l9.4,8c0.2,0.2,0.6,0.2,0.9,0.1c0.3-0.1,0.5-0.3,0.5-0.7v-5.1h25.8c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-4.4C70,48.9,69.9,48.7,69.8,48.5L69.8,48.5z'
						});
					}
				}


				// Section Events
				var $eventSection = $('.section_events');
				if ($eventSection.length > 0) {
					var flkty = new Flickity('.section_events-carousel', {
						cellAlign: 'left',
						percentPosition: true,
						contain: false,
						pageDots: false,
						imagesLoaded: true,
						cellSelector: '.carousel-cell',
						arrowShape: 'M50,0c27.6,0,50,22.4,50,50s-22.4,50-50,50S0,77.6,0,50S22.4,0,50,0z M69.8,48.5c-0.2-0.1-0.4-0.2-0.6-0.2H43.4v-5.1c0-0.3-0.2-0.5-0.5-0.7c-0.3-0.1-0.6-0.1-0.9,0.1l-9.4,8.1c-0.2,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.4,0.2,0.5l9.4,8c0.2,0.2,0.6,0.2,0.9,0.1c0.3-0.1,0.5-0.3,0.5-0.7v-5.1h25.8c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-4.4C70,48.9,69.9,48.7,69.8,48.5L69.8,48.5z'
					});
				}


				// Modals
				$(document).on('click', '.js-person-modal', function(evt) {
					evt.preventDefault();
					var $person = $(evt.target).closest('.person');

					var personImage = $person.find('.person_image').html();
					var personContent = $person.find('.person_content').html();

					$('.modal_content').html(personContent);
					$('.modal_image').html(personImage);
					$('.modal-wrapper').addClass('modal--open');
					$.scrollLock();
				});

				$(document).on('click', '.js-product-modal', function (evt) {
					evt.preventDefault();
					var $product = $(evt.target).closest('.product');

					var productImage = $product.find('.entry_image').html();
					$('.modal_image').html(productImage);

					var productContent = $product.find('.product_content').html();
					$('.modal_content').html(productContent);

					$('.modal-wrapper').addClass('modal--open');
					$.scrollLock();

				});

				$(document).on('click', '[data-show-form]', function (evt) {

					var $button = $(evt.target).closest('[data-show-form]');
					const formId = $button.data('show-form');
					const product = document.getElementById(formId);
					const formContent = product.innerHTML;
					$('.modal_content').html(formContent);

				});


				$(document).on('click', '.modal-wrapper', function(evt) {
					evt.preventDefault();
					$('.modal-wrapper').removeClass('modal--open');
					$.scrollLock();
				}).on('click', '.modal', function(evt) {
					evt.stopPropagation();
				});

				$(document).on('click', '.js-close-modal', function(evt) {
					evt.preventDefault();
					$('.modal-wrapper').removeClass('modal--open');
					$.scrollLock();
				});





				// History
				$(document).on('click', '.history_button', function(evt) {
					evt.preventDefault();
					$(evt.target).closest('.history').toggleClass('history--open');
				});



				// Stories
				var mixContainer = $('.stories-mixer');
				var filteredTags = [];
				var $storyCards = $('.storyentry');
				var $filteredTagsList = $('.filter-badge');

				if(mixContainer.length) {
					var mixer = mixitup('.stories-mixer', {
						animation: {
							animateResizeContainer: false,
							effects: 'fade scale'
						},
						multifilter: {
							enable: true // enable the multifilter extension for the mixer
						},
						callbacks: {
							onMixEnd: function (state, futureState) {
								checkFilters();
							}
						}
					});
				}


				var checkFilters = function() {
					filteredTags = [];
					var checkedInputs = $('.filtermodal__columns').find('input:checked');
					if (checkedInputs.length) {
						checkedInputs.each(function () {
							filteredTags.push($(this).attr('id'));
						});
						$('body').addClass('stories--filtered');
					} else {
						$('body').removeClass('stories--filtered');
					}
					$filteredTagsList.each(function () {
						var tag = $(this).attr('data-tag');
						$(this).removeClass('filter-badge--visible');
						if ($.inArray(tag, filteredTags) > -1) {
							$(this).addClass('filter-badge--visible');
						}
					});
				}

				$(document).on('click', '.checkbox', function(evt) {
					checkFilters();
				});

				$(document).on('click', '.filter-badge', function(evt) {
					evt.preventDefault();
					var clickedTag = $(this).attr('data-tag');
					$('[data-filter-group]').find('#' + clickedTag).trigger('click');
					let checkbox = document.querySelector('#' + clickedTag);
					mixer.parseFilterGroups();
				});


				// Filter modal
				$(document).on('click', '.body--filter', function (evt) {
					evt.preventDefault();
					$('body').removeClass('body--filter');
					if ($(window).width() < 992) {
						$.scrollLock();
					}
				}).on('click', '.filtermodal', function (evt) {
					evt.stopPropagation();
				});

				$(document).on('click', '.js-filter-open', function (evt) {
					evt.preventDefault();
					$('body').addClass('body--filter');
					if ($(window).width() < 992) {
						$.scrollLock();
					}
				});

				$(document).on('click', '.js-filter-close', function (evt) {
					evt.preventDefault();
					$('body').removeClass('body--filter');
					if($(window).width() < 992) {
						$.scrollLock();
					}
				});


				// Explore modal
				$(document).on('click', '.body--explore', function (evt) {
					evt.preventDefault();
					$('body').removeClass('body--explore');
					if ($(window).width() < 992) {
						$.scrollLock();
					}
				}).on('click', '.exploremodal', function (evt) {
					evt.stopPropagation();
				});

				$(document).on('click', '.js-explore-open', function (evt) {
					evt.preventDefault();
					$('body').addClass('body--explore');
					if ($(window).width() < 992) {
						$.scrollLock();
					}
				});

				$(document).on('click', '.js-explore-close', function (evt) {
					evt.preventDefault();
					$('body').removeClass('body--explore');
					if ($(window).width() < 992) {
						$.scrollLock();
					}
				});



				// Newsletter submit
				$(document).on('click', '#js-newsletter-submit', function() {
					$('#mc-embedded-subscribe-form').submit();
				});






				// Explore map
				var googleMapsInterval = setInterval(function () {
					if (typeof google != 'undefined') {
						clearInterval(googleMapsInterval);
						initMap();
					}
				}, 100);

				var map, popup, Popup;

				//Start Google Maps
				function initMap() {
					definePopupClass();

					$('.acf-map').each(function () {
						var $el = $(this);

						var $markers = $el.find('.marker');
						var args = {
							zoom: 2,
							backgroundColor: '#73c1ea',
							center: new google.maps.LatLng(21, 13),
							mapTypeId: google.maps.MapTypeId.ROADMAP,
							scrollwheel: false,
							disableDefaultUI: false,
							styles: [
								{
									"featureType": "administrative",
									"elementType": "labels.text.fill",
									"stylers": [
										{
											"color": "#444444"
										}
									]
								},
								{
									"featureType": "landscape",
									"elementType": "all",
									"stylers": [
										{
											"color": "#f2f2f2"
										}
									]
								},
								{
									"featureType": "poi",
									"elementType": "all",
									"stylers": [
										{
											"visibility": "off"
										}
									]
								},
								{
									"featureType": "road",
									"elementType": "all",
									"stylers": [
										{
											"saturation": -100
										},
										{
											"lightness": 45
										}
									]
								},
								{
									"featureType": "road.highway",
									"elementType": "all",
									"stylers": [
										{
											"visibility": "simplified"
										}
									]
								},
								{
									"featureType": "road.arterial",
									"elementType": "labels.icon",
									"stylers": [
										{
											"visibility": "off"
										}
									]
								},
								{
									"featureType": "transit",
									"elementType": "all",
									"stylers": [
										{
											"visibility": "off"
										}
									]
								},
								{
									"featureType": "water",
									"elementType": "all",
									"stylers": [
										{
											"color": "#73c1ea"
										},
										{
											"visibility": "on"
										}
									]
								}
							]
						};

						map = new google.maps.Map($el[0], args);

						map.markers = [];

						$markers.each(function () {
							add_marker($(this), map);
						});

						center_map(map);

						$(document).on('click', '.js-explore-open', function() {
							center_map(map);
						});


					});

					/** Defines the Popup class. */
					function definePopupClass() {
						/**
						 * A customized popup on the map.
						 * @param {!google.maps.LatLng} position
						 * @param {!Element} content
						 * @constructor
						 * @extends {google.maps.OverlayView}
						 */
						Popup = function (position, content) {
							this.position = position;

							content.classList.add('popup-bubble-content');

							var pixelOffset = document.createElement('div');
							pixelOffset.classList.add('popup-bubble-anchor');
							pixelOffset.appendChild(content);

							this.anchor = document.createElement('div');
							this.anchor.classList.add('popup-tip-anchor');
							this.anchor.appendChild(pixelOffset);

							// Optionally stop clicks, etc., from bubbling up to the map.
							this.stopEventPropagation();
						};
						// NOTE: google.maps.OverlayView is only defined once the Maps API has
						// loaded. That is why Popup is defined inside initMap().
						Popup.prototype = Object.create(google.maps.OverlayView.prototype);


						/** Called when the popup is added to the map. */
						Popup.prototype.onAdd = function () {
							this.getPanes().floatPane.appendChild(this.anchor);
						};

						/** Called when the popup is removed from the map. */
						Popup.prototype.onRemove = function () {
							if (this.anchor.parentElement) {
								this.anchor.parentElement.removeChild(this.anchor);
							}
						};

						/** Called when the popup needs to draw itself. */
						Popup.prototype.draw = function () {
							var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
							// Hide the popup when it is far out of view.
							var display =
								Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
									'block' :
									'none';

							if (display === 'block') {
								this.anchor.style.left = divPosition.x + 'px';
								this.anchor.style.top = divPosition.y + 'px';
							}
							if (this.anchor.style.display !== display) {
								this.anchor.style.display = display;
							}

							this.anchor.style.visibility = 'hidden';
						};

						// Set the visibility to 'hidden' or 'visible'.
						Popup.prototype.hide = function () {
							this.anchor.style.visibility = 'hidden';
						};
						Popup.prototype.show = function () {
							this.anchor.style.visibility = 'visible';
						};

						Popup.prototype.toggle = function(latlng) {
							if (this.anchor.style.visibility === 'hidden') {
								var that = this;
								that.panToView(latlng, that);
							} else {
								this.hide();
							}
						};

						/** Stops clicks/drags from bubbling up to the map. */
						Popup.prototype.stopEventPropagation = function () {
							var anchor = this.anchor;
							anchor.style.cursor = 'auto';

							['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart',
								'pointerdown']
								.forEach(function (event) {
									anchor.addEventListener(event, function (e) {
										e.stopPropagation();
									});
								});
						};

						/**
						 * Pan the InfoBubble into view
						 */
						Popup.prototype.panToView = function (markerLatLng, popover) {

							var projection = this.getProjection();

							if (!projection) {
								// The map projection is not ready yet so do nothing
								return;
							}

							if (!this.anchor) {
								// No Bubble yet so do nothing
								return;
							}

							var $bubble = $(this.anchor).find('.marker')


							var autopanMargin = 20;										// get the edge margin from options (or default)
							var infobubbleHeight = $bubble.height() - 30;    // height of the infobubble - pixels
							var infobubbleWidth = $bubble.width() + 30;									    // width of the infobubble - pixels

							var map = this.get('map');
							var mapDiv = map.getDiv();															// the div containing the map
							var mapHeight = mapDiv.offsetHeight;											    	// height of the div containing the map - pixels
							var mapWidth = mapDiv.offsetWidth;													// height of the div containing the map - pixels

							// coordinate of the marker - lat/lng
							var markerPosition = projection.fromLatLngToContainerPixel(markerLatLng);				// the marker position - pixels
							var mapCenter = projection.fromLatLngToContainerPixel(map.getCenter());			    // centre of the map - pixels


							var spaceTop = markerPosition.y - infobubbleHeight - autopanMargin;	// calculate free space or overrun at the top (including the autopan margin) - pixels
							var spaceRight = mapWidth - markerPosition.x - autopanMargin;		// calculate free space or overrun on the right (including the autopan margin) - pixels
							var spaceLeft = markerPosition.x - infobubbleWidth - autopanMargin;				// calculate free space or overrun on the left (including the autopan margin) - pixels

							if (spaceTop < 0) {
								mapCenter.y += spaceTop;				// if spaceTop is -ve, we have to move the map centre UP (ie delete the difference from the y-axis value) - hence we add the -ve spaceTop value
							}
							if (spaceRight < 0) {
								mapCenter.x -= spaceRight;			// if spaceRight is -ve, we have to move the map centre RIGHT (ie add the difference to the x-axis value) - hence we minus the -ve spaceRight value
							}
							if (spaceLeft < 0) {
								mapCenter.x += spaceLeft;				// if spaceLeft is -ve, we have to move the map centre LEFT (ie delete the difference to the x-axis value) - hence we add the -ve spaceRight value
							}

							var newMapCenterlatLng = projection.fromContainerPixelToLatLng(mapCenter);

							if (map.getCenter() != newMapCenterlatLng) {
								map.panTo(newMapCenterlatLng);
								setTimeout(function () {
									popover.show();
								}, 400);
							}
						};
						Popup.prototype['panToView'] = Popup.prototype.panToView;

					}

					function add_marker($marker, map) {
						var latlng = new google.maps.LatLng($marker.data('lat'), $marker.data('lng'));
						var permaLink = $marker.data('permalink');

						// create marker
						var marker = new google.maps.Marker({
							position: latlng,
							map: map,
							icon: '../../app/themes/cityateyelevel/dist/images/map-pin.svg',
							originalicon: '../../app/themes/cityateyelevel/dist/images/map-pin.svg',
							hovericon: '../../app/themes/cityateyelevel/dist/images/map-pin--hovered.svg'
						});
						map.markers.push(marker);

						// if marker contains HTML, add it to an infoWindow
						if ($marker.html()) {

							var popup = new Popup(
								latlng,
								$marker[0]
							);
							popup.setMap(map);

							google.maps.event.addListener(marker, 'click', function () {
								popup.toggle(latlng);
							});
							google.maps.event.addListener(marker, "mouseover", function () {
								this.setIcon(this.hovericon);
								this.setOptions({ zIndex: 10 });
							});
							google.maps.event.addListener(marker, "mouseout", function () {
								this.setIcon(this.originalicon);
								this.setOptions({ zIndex: 1 });
							});

						}

					}

					function center_map(map) {

						var bounds = new google.maps.LatLngBounds();

						// loop through all markers and create bounds
						$.each(map.markers, function (i, marker) {
							var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
							bounds.extend(latlng);
						});

						//setTimeout(function() {
							if (map.markers.length == 1) {
								map.setCenter(bounds.getCenter());
							} else {
								map.fitBounds(bounds);
							}
						//}, 3000);



					}

				}



			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Starter;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

  	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
